import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ValidatedInput from "integrations/aws/common/ValidatedInput";
import MaskedInput from "integrations/aws/common/MaskedInput";
const StyledMaskedInput = styled(MaskedInput)`
  margin-bottom: 0;
`;
const KeySecret = ({ onChange, awsKey = void 0, awsSecret = void 0, required = true }) => {
  const { t } = useTranslation("integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    ValidatedInput,
    {
      id: "awsAccessKey",
      type: "text",
      label: t("aws_key_secret.access_key_label"),
      placeholder: t("aws_key_secret.access_key_placeholder"),
      onChange,
      fieldData: awsKey,
      autoComplete: "off",
      maxLength: 512,
      help: required ? t("aws_key_secret.access_key_help") : t("aws_key_secret.access_key_help_optional"),
      required
    }
  ), /* @__PURE__ */ React.createElement(
    StyledMaskedInput,
    {
      id: "awsSecretKey",
      label: t("aws_key_secret.secret_key_label"),
      placeholder: t("aws_key_secret.secret_key_placeholder"),
      onChange,
      fieldData: awsSecret,
      autoComplete: "off",
      maxLength: 512,
      help: required ? t("aws_key_secret.secret_key_help") : t("aws_key_secret.secret_key_help_optional"),
      required
    }
  ));
};
export default KeySecret;
